<template>
  <div v-if="showBanner || show" class="banner-container">
    <span class="text">
      <span class="font-weight-bolder">{{ computedBoldText }} </span> {{ computedText }}
    </span>
    <a v-if="isExternalLink" :href="buttonLink" target="_blank" class="btn btn-feedback">{{
      computedButtonText
    }}</a>
    <Button
      v-else
      class="button-text"
      color="white"
      :text-color="experience"
      :to="computedButtonLink"
    >
      {{ computedButtonText }}
    </Button>
  </div>
</template>

<script>
import Button from 'UI/Button';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Banner',
  components: {
    Button
  },
  props: {
    text: {
      type: String,
      default: null
    },
    buttonText: {
      type: String,
      default: null
    },
    boldText: {
      type: String,
      default: null
    },
    buttonLink: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('search', ['isSearching']),
    ...mapState('search', ['searchResult']),
    ...mapGetters('experience', ['getExperience', 'getDefault']),
    showBanner() {
      return (
        !this.isSearching &&
        this.searchResult.length > this.$g('SEARCH_NOT_ENOUGH_RESULTS') &&
        (!this.$auth.loggedIn || this.$auth.user.idPlan === 1)
      );
    },
    experience() {
      return this.getExperience || this.getDefault;
    },
    computedText() {
      return this.text;
    },
    computedButtonText() {
      return this.buttonText;
    },
    computedBoldText() {
      return this.boldText;
    },
    computedButtonLink() {
      return this.buttonLink;
    },
    isExternalLink() {
      if (this.buttonLink) {
        return this.buttonLink.includes('http');
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
$btn-primary-color: #fff;
$btn-hover-color: #0056b3;
$btn-shadow-color: rgba(0, 123, 255, 0.5);
.banner-container {
  width: 100%;
  background-color: var(--exp-color);
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;
  margin: 15px 0;
  .text {
    margin: 0 10px;
    color: white;
  }
  .button-text {
    text-transform: uppercase;
  }

  .btn-feedback {
    background-color: $btn-primary-color;
    color: #007bff;
    border-radius: 20px;
    border: none;
    padding: 8px 20px;
    font-size: 16px;
    box-shadow: 0 2px 4px $btn-shadow-color;
    text-transform: uppercase;

    &:hover,
    &:focus {
      filter: brightness(1.15);
      text-decoration: none;
      box-shadow: 0 2px 8px $btn-shadow-color;
    }
  }
}
</style>
